import {
  LayoutDashboard, ShoppingCart, Truck, Boxes, Factory, Ship, Wrench, FlaskConical,
  Landmark, Users, Store, Package, BarChart3, Database, ShieldCheck, Settings,
} from 'lucide-react';

export const HERO_IMG = 'https://static.prod-images.emergentagent.com/jobs/5b73f0a1-09e6-4714-a573-f0f3a62d0bf4/images/e45646471f75bce98a02fbaec46041d309c218d02ea5fdf4632717ce403cfc28.jpeg';

// view keys map to routes /erp/<view>. `soon` marks Phase-2 modules.
export const NAV = [
  { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { key: 'sales', label: 'Sales', icon: ShoppingCart, children: [{ key: 'sales/quotations', label: 'Quotations' }, { key: 'sales/orders', label: 'Sales Orders' }, { key: 'sales/invoices', label: 'Invoices' }, { key: 'sales/dispatch', label: 'Dispatch' }] },
  { key: 'purchase', label: 'Purchase', icon: Truck, children: [{ key: 'purchase/indents', label: 'Indents' }, { key: 'purchase/orders', label: 'Purchase Orders' }, { key: 'purchase/grn', label: 'GRN' }] },
  { key: 'inventory', label: 'Inventory', icon: Boxes, children: [{ key: 'inventory', label: 'Stock Position' }, { key: 'inventory/ledger', label: 'Stock Ledger' }] },
  { key: 'manufacturing', label: 'Manufacturing (VCI)', icon: Factory, soon: true, children: ['Production Entry', 'BOM', 'WIP'] },
  { key: 'import', label: 'Import', icon: Ship, soon: true, children: ['Shipments', 'Landed Cost'] },
  { key: 'jobwork', label: 'Job Work', icon: Wrench, soon: true, children: ['Issue', 'Receipt'] },
  { key: 'trial', label: 'Trial Material', icon: FlaskConical, soon: true, children: ['Issue', 'Return'] },
  { key: 'finance', label: 'Finance & Accounts', icon: Landmark, soon: true, children: ['Receivables', 'Payables', 'Tally Sync'] },
  { key: 'customers', label: 'Customers', icon: Users },
  { key: 'vendors', label: 'Vendors', icon: Store },
  { key: 'products', label: 'Products', icon: Package },
  { key: 'reports', label: 'Reports & MIS', icon: BarChart3, soon: true, children: ['Sales MIS', 'Stock Ageing', 'Pendency'] },
  { key: 'masters', label: 'Masters', icon: Database, children: [{ key: 'masters', label: 'Companies' }, { key: 'masters/branches', label: 'Branches' }, { key: 'masters/financial-years', label: 'Financial Years' }] },
  { key: 'administration', label: 'Administration', icon: ShieldCheck, children: [{ key: 'administration', label: 'Users & Roles' }] },
];

export const SETTINGS_NAV = { key: 'settings', label: 'Settings', icon: Settings, soon: true };

export const findNav = (view) => {
  const top = view.split('/')[0];
  return NAV.find((n) => n.key === top) || (top === 'settings' ? SETTINGS_NAV : NAV[0]);
};
